define((require) => {
    "use strict";

    const $              = require("jquery");
    const _              = require("underscore");
    const CustomJsAction = require("shared/ui/experience/action/customJs/CustomJsAction");
    const ImprovedView   = require("editor/zbone/ImprovedView");
    const template       = require("ui/experience/action/ParametersPropertiesView.tpl");
    const Tooltip        = require("ui/common/Tooltip");

    /**
     * Properties view for a custom js action.
     *
     * @class CustomJsActionPropertiesView
     *
     * @cfg {CustomJsAction} model The action to display in the view.
     */
    return ImprovedView.extend({

        /**
         * @private @type {String}
         * The last validation error, if any, for an invalid parameter value for any parameter.
         */
        _displayedError: null,

        _errors: null,

        template,

        ui: {
            parameterInputs: ".parameter-inputs input"
        },

        events: {
            "blur  @ui.parameterInputs": "_handleParameterBlur",
            "focus @ui.parameterInputs": "_handleParameterChange",
            "keyup @ui.parameterInputs": "_handleParameterChange"
        },

        initialize() {
            this._errors = new Map();
        },

        onShow() {
            Tooltip.add(this.ui.parameterInputs, {
                content() {
                    return _.escape(this._displayedError);
                },
                trigger:   "manual", // Tooltips are toggled by adding/removing validation-error CSS class.
                width:     200,
                placement: "left"
            });
        },

        onClose() {
            Tooltip.remove(this.ui.parameterInputs);
        },

        /**
         * Sets the actual parameters in the model as the users type them in in
         * the properties view.
         *
         * @param {Event} event - The keyup event.
         */
        _handleParameterChange: _.debounce(function(event) {
            const el = event.target;
            const label = el.getAttribute("data-label");
            const parameters = _.clone(this.model.get("parameters"));
            let oldValue;

            // Sanity check.
            if (!parameters.hasOwnProperty(label)) {
                return;
            }
            // Inserting the value and checking the code will actually run.
            oldValue = parameters[label];
            // Ignore non-changes.
            const newValue = oldValue !== el.value;
            // Set change.
            parameters[label] = el.value;

            let errorMessage = CustomJsAction.checkParameter(label, el.value);
            const hasError = !!errorMessage;

            if (hasError) {
                this._errors.set(label, errorMessage);
            } else {
                this._errors.delete(label);
            }

            // On no errors, we must still check the code to see if it can run.
            if (this._errors.size === 0) { // Never true if "newError" is true.
                errorMessage = this.model.checkCode();
            }

            // To avoid flickering tooltip on for example arrow key navigation.
            const sameError = errorMessage === this._displayedError;

            // Error to display.
            this._displayedError = errorMessage;

            // Revert error if invalid, including if the code cannot run.
            if (hasError) {
                parameters[label] = oldValue || "";

            // Only trigger model change if all parameters and code are valid and we have an actual
            // change.
            } else if (!this._errors.size && newValue) {
                const newParameters = {};
                this.$el.find(this.ui.parameterInputs).each((index, parameterInput) => {
                    const label = parameterInput.dataset.label;
                    if (label) {
                        newParameters[label] = parameterInput.value;
                    }
                });

                this.model.set("parameters", newParameters);
            }

            if (!sameError) {
                $(el).toggleClass("validation-error", hasError).popover(hasError ? "show" : "hide");
            }
        }, 300),

        _hideError(event) {
            const el = event.target;
            const $el = $(el);

            this._displayedError = null;
            $el.popover("hide");
        },

        _handleParameterBlur(e) {
            this._handleParameterChange(e);
            this._hideError(e);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/customJs/CustomJsActionPropertiesView.js